<template>
  <div v-if="showWidget" class="novidades-preview">
    <template v-if="previewType === 'tags'">
      <div class="novidades-preview__head">
        <span>
          <v-icon x-small class="mr-1" color="#059669">fas fa-tag</v-icon>
          Simulação de Escopo da Etiqueta:
        </span>
        <div class="novidades-preview__toggle">
          <button
            type="button"
            class="novidades-preview__toggle-btn"
            :class="{
              'novidades-preview__toggle-btn--active': tagMode === 'conversa'
            }"
            @click="tagMode = 'conversa'"
          >
            Por Conversa
          </button>
          <button
            type="button"
            class="novidades-preview__toggle-btn"
            :class="{
              'novidades-preview__toggle-btn--active': tagMode === 'cliente'
            }"
            @click="tagMode = 'cliente'"
          >
            Por Cliente
          </button>
        </div>
      </div>
      <div>
        <span class="novidades-preview__pill">
          <span class="novidades-preview__dot" style="background:#10b981" />
          Atendimento VIP ({{
            tagMode === "conversa" ? "Esta conversa" : "Cliente geral"
          }})
        </span>
        <span class="novidades-preview__pill">
          <span class="novidades-preview__dot" style="background:#2563eb" />
          Orçamento em Análise
        </span>
        <span class="novidades-preview__pill">
          <span class="novidades-preview__dot" style="background:#f59e0b" />
          Pós-venda Prioritário
        </span>
      </div>
    </template>

    <template v-else-if="previewType === 'images'">
      <div class="novidades-preview__head">
        <span>
          <v-icon x-small class="mr-1" color="#2563eb">fas fa-sync-alt</v-icon>
          Pipeline de Sincronização Automática ERP:
        </span>
        <button
          type="button"
          class="novidades-preview__toggle-btn"
          style="border:none;background:transparent;color:#2563eb;font-size:11px;cursor:pointer"
          @click="runSyncDemo"
        >
          Testar Sincronização
        </button>
      </div>
      <div class="novidades-preview__grid-2">
        <div
          class="novidades-preview__mini-card d-flex align-center"
          style="gap:8px"
        >
          <div
            style="width:32px;height:32px;border-radius:8px;background:#dbeafe;color:#2563eb;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:11px"
          >
            ERP
          </div>
          <div>
            <div style="font-weight:600">Cadastro Original</div>
            <div style="font-size:11px;color:var(--np-text-soft)">
              SKU: LF-9941
            </div>
          </div>
        </div>
        <div
          class="novidades-preview__mini-card d-flex align-center"
          style="gap:8px"
        >
          <div
            style="width:32px;height:32px;border-radius:8px;background:#d1fae5;color:#059669;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:11px"
          >
            WEB
          </div>
          <div>
            <div style="font-weight:600">Catálogo Atualizado</div>
            <div style="font-size:11px;color:#059669">
              {{ erpSynced ? "Resolução Otimizada WebP" : "Sincronizando..." }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="previewType === 'payment'">
      <div class="novidades-preview__head">
        <span>
          <v-icon x-small class="mr-1" color="#4f46e5"
            >fas fa-credit-card</v-icon
          >
          Estrutura de Agrupamento Visual de Meios de Pagamento:
        </span>
      </div>
      <div class="novidades-preview__grid-2">
        <div class="novidades-preview__mini-card">
          <div style="font-weight:700;margin-bottom:4px">
            <span class="novidades-preview__dot" style="background:#10b981" />
            À Vista & Instantâneo
          </div>
          <div style="font-size:11px;color:var(--np-text-soft)">
            Pix Dinâmico (5% OFF) · Cartão de Débito
          </div>
        </div>
        <div class="novidades-preview__mini-card">
          <div style="font-weight:700;margin-bottom:4px">
            <span class="novidades-preview__dot" style="background:#2563eb" />
            Parcelado & B2B Faturado
          </div>
          <div style="font-size:11px;color:var(--np-text-soft)">
            Boleto a Prazo (30/60 dias) · Até 10x Cartão
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
const PREVIEW_TYPES = ["tags", "images", "payment"];

export default {
  name: "ImprovementPreviewWidget",
  props: {
    improvement: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    tagMode: "conversa",
    erpSynced: true,
    syncTimer: null
  }),
  computed: {
    previewType() {
      return this.improvement && this.improvement.previewType;
    },
    showWidget() {
      return PREVIEW_TYPES.includes(this.previewType);
    }
  },
  beforeDestroy() {
    if (this.syncTimer) clearTimeout(this.syncTimer);
  },
  methods: {
    runSyncDemo() {
      this.erpSynced = false;
      if (this.syncTimer) clearTimeout(this.syncTimer);
      this.syncTimer = setTimeout(() => {
        this.erpSynced = true;
      }, 800);
    }
  }
};
</script>
